import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { getUserNotificationUsers } from '../../api/brokers';
import LoadingPage from '../Loading/loading';
import { sendNotification } from '../../api/notifications';

const NotificationComponent = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [message, setMessage] = useState('');
    const [link, setLink] = useState('');
    const [image, setImage] = useState(null);
    const [ids, setIds] = useState([])
    const [notifications, setNotifications] = useState(null);
    const [notificationsFinal, setNotificationsFinal] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getUserNotificationUsers(props.userType).then((result) => {
            setNotifications(result.data.response)
            setNotificationsFinal(result.data.response)
        })
    }, [])

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value) {
            setNotificationsFinal(notifications.filter(user =>
                user.name.toLowerCase().includes(value.toLowerCase()) ||
                user.phone.toLowerCase().includes(value.toLowerCase())
            ));
        } else {
            setNotificationsFinal(notifications);
        }
    };

    const toggleSelect = (id) => {
        setIds(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id); // Remove ID if already selected
            } else {
                return [...prev, id]; // Add ID if not selected
            }
        });
    };

    const selectAllNotifications = () => {
        const allIds = notifications.map(notification => notification._id);
        setIds(allIds);
    };

    // Clear all selections
    const clearAllSelections = () => {
        setIds([]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const formBack = new FormData();
        formBack.append("image", image);
        formBack.append("link", link);
        formBack.append("users", JSON.stringify(ids));
        formBack.append("text", message);
        sendNotification(formBack).then((result) => {
            setMessage('');
            setLink('');
            setImage(null);
            setIds([])
            setLoading(false)
        })

    };

    return (
        <>{notificationsFinal === null ? (<LoadingPage />) : (<div>
            <div className="search-container">
                <div className="search-input-wrapper">
                    <FiSearch className="search-icon" />
                    <input
                        type="text"
                        placeholder="Name or Phone number"
                        value={searchTerm}
                        onChange={handleSearch}
                        className="search-input"
                    />
                </div>

                <br />

                <form onSubmit={handleSubmit}>
                    <div className="search-input-wrapper">
                        <textarea
                            type="text"
                            placeholder="Message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="search-input2"
                            required
                            onInvalid={(e) => e.target.setCustomValidity("Message is required")}
                        />

                        <div style={{ padding: "5px" }} />

                        <input
                            type="text"
                            placeholder="Link"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            className="search-input2"
                        />
                    </div>

                    <div>
                        {image && <img src={URL.createObjectURL(image)} alt="Uploaded" style={{ maxWidth: '250px', maxHeight: '250px', padding: "10px" }} />}
                        <input
                            type="file"
                            id="image"
                            name="image"
                            onChange={(e) => setImage(e.target.files[0])}
                            accept="image/*"
                        />
                    </div>

                    {loading ? <div style={{
                        width: "100%",
                        justifyContent: "center",
                        display: "flex"
                    }}>
                        <div className="spinner"></div>
                    </div> : <button type="submit" className="submit-button" style={{ width: "150px" }}>
                        Submit
                    </button>}
                </form>

                <br />

                {!searchTerm && <div>
                    <input
                        type="checkbox"
                        checked={ids.length === notificationsFinal.length}
                        onChange={() => {
                            if (ids.length !== notificationsFinal.length) {
                                selectAllNotifications()
                            } else {
                                clearAllSelections()
                            }
                        }}
                        className="client-checkbox"
                    />
                    <span className="label">Select all</span>
                </div>}
            </div>

            <div className="card-cards">
                {notificationsFinal?.map(notification => (
                    <div key={notification._id} className={`card-card ${notification.isBanned ? 'banned' : ''}`} onClick={() => toggleSelect(notification._id)}>
                        <div className="card-info">
                            <input
                                type="checkbox"
                                checked={ids.includes(notification._id)}
                                className="client-checkbox"
                            />
                            <div>
                                <p className='line'><span className="label">Name:</span> {notification.name}</p>
                                <p className='line'><span className="label">Phone:</span> {notification.phone}</p>
                                <p className='line'><span className="label">Join at:</span> {notification.createdAt.split("T")[0]}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>)}</>
    );
};

export default NotificationComponent;